import { ProductMessageType } from '@/graphql/generated/schemas'

/**
 * Shape react-select (and therefore `Controller as={InputSelect}`) stores in form
 * state — the whole option object, not the bare enum value.
 */
export type ProductMessageTypeOption = {
  value: ProductMessageType
  label: string
}

/**
 * Single source of truth for message-type copy, keyed by the enum so the API's
 * `messageType` can be turned into form state with a plain lookup. Keyed as a full
 * `Record` on purpose: a value added to the enum by `yarn codegen` fails to compile
 * here rather than resolving `undefined` at a call site. Key order is dropdown order.
 */
export const messageTypeOptionsByType: Record<
  ProductMessageType,
  ProductMessageTypeOption
> = {
  [ProductMessageType.Info]: { value: ProductMessageType.Info, label: 'Info' },
  [ProductMessageType.Success]: {
    value: ProductMessageType.Success,
    label: 'Success',
  },
  [ProductMessageType.Warning]: {
    value: ProductMessageType.Warning,
    label: 'Warn',
  },
  [ProductMessageType.Error]: {
    value: ProductMessageType.Error,
    label: 'Error',
  },
}

export const messageTypeOptions: Array<ProductMessageTypeOption> =
  Object.values(messageTypeOptionsByType)

/** Neutral notice — the default for a newly authored announcement. */
export const DEFAULT_MESSAGE_TYPE_OPTION =
  messageTypeOptionsByType[ProductMessageType.Info]
